import { css } from '@emotion/react';
import { type FC } from 'react';
import { Stack } from '~/_shared/baseComponents/layout/Stack.componment';
import { linkStyle } from '~/_shared/baseComponents/links';
import {
  SAMPLE_SPREADSHEET_FILE_NAME, SampleSpreadsheetUrl,
} from '~/_shared/constants/sampleData';
import type { Theme } from '~/_shared/themes/theme.model';
import {
  s, Trans,
} from '~/translations/Trans';
import { useTranslation } from '../../utils/hooks';

const modalFooterContainerStyle = css({
  cursor: 'default',
  fontSize: 14,
  lineHeight: 1.2,
  margin: 0,
});

const modalFooterHeadingStyle = (theme: Theme) => css({
  margin: 0,
  color: theme.textColors.success,
});

const modalFooterParagraphStyle = css({
  margin: 0,
});

const hereLinkParagraphStyle = (isDisabled: boolean) => css({
  margin: 0,
  opacity: isDisabled ? 0.5 : undefined,
  pointerEvents: isDisabled ? 'none' : undefined,
});

const hereLinkStyle = (theme: Theme) => css({
  background: 'none',
  border: 'none',
  color: theme.textColors.tertiary,
  cursor: 'pointer',
  fontWeight: 'bold',
  padding: 0,
  textDecoration: 'underline',

  '&:hover': {
    color: theme.textColors.linkOnHover,
  },
});

type ModalFooterSampleExcelProps = {
  isDisabled?: boolean;
  onUseSampleData?: () => void;
};

export const ModalFooterSampleExcelComponent: FC<ModalFooterSampleExcelProps> = ({ isDisabled, onUseSampleData }) => {
  const [t] = useTranslation();

  return (
    <Stack css={modalFooterContainerStyle} gap={2}>
      <p css={modalFooterHeadingStyle}>{t('Need Help?')}</p>
      <p css={modalFooterParagraphStyle}>
        <Trans i18nKey="sampleData.download">
          {s('prefix')}
          <a
            css={linkStyle({ isDestructive: false })}
            href={SampleSpreadsheetUrl}
            download={SAMPLE_SPREADSHEET_FILE_NAME}
          >
            sample
          </a>
          {s('suffix')}
        </Trans>
      </p>
      <p css={hereLinkParagraphStyle(!!isDisabled)}>
        <Trans i18nKey="sampleData.mapClickHere">
          {s('prefix')}
          <button
            css={hereLinkStyle}
            disabled={isDisabled}
            onClick={() => onUseSampleData?.()}
          />
          {s('suffix')}
        </Trans>
      </p>
    </Stack>
  );
};
